"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return formulaQueryBuilderv2;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _dbHelpers = require("src/helpers/dbHelpers");
const _extractor = require("src/helpers/db-error/extractor");
const _genRollupSelectv2 = /*#__PURE__*/ _interop_require_default(require("../genRollupSelectv2"));
const _pg = require("../aggregations/pg");
const _sqlite3 = require("../aggregations/sqlite3");
const _lookuporltarbuilder = require("./lookup-or-ltar-builder");
const _parsedtreebuilder = require("./parsed-tree-builder");
const _utils = require("~/helpers/db-error/utils");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _FormulaColumn = /*#__PURE__*/ _interop_require_default(require("~/models/FormulaColumn"));
const _globals = require("~/utils/globals");
const _telemetryhandlerservice = require("~/services/telemetry-handler.service");
const _getRelatedModelMap = require("~/utils/getRelatedModelMap");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const logger = new _common.Logger('FormulaQueryBuilderv2');
async function _formulaQueryBuilder(params) {
    const { baseModelSqlv2, _tree, model, aliasToColumn = {}, columnIdToUidt = {}, tableAlias, parsedTree, column = null, columns, getAliasCount } = params;
    let { baseUsers = null } = params;
    const knex = baseModelSqlv2.dbDriver;
    const context = baseModelSqlv2.context;
    let tree = parsedTree;
    if (!tree) {
        const relatedModels = await (0, _getRelatedModelMap.getRelatedModelMap)(context, model);
        // formula may include double curly brackets in previous version
        // convert to single curly bracket here for compatibility
        // const _tree1 = jsep(_tree.replaceAll('{{', '{').replaceAll('}}', '}'));
        tree = await (0, _nocodbsdk.validateFormulaAndExtractTreeWithType)({
            formula: _tree.replaceAll('{{', '{').replaceAll('}}', '}'),
            columns,
            column,
            clientOrSqlUi: baseModelSqlv2.clientType,
            getMeta: async (_, { id })=>{
                return relatedModels.get(id);
            }
        });
        // populate and save parsedTree to column if not exist
        if (column) {
            if (column.uidt === _nocodbsdk.UITypes.Formula) {
                _FormulaColumn.default.update(context, column.id, {
                    parsed_tree: tree
                }).then(()=>{
                // ignore
                }, (err)=>{
                    logger.error(err);
                });
            } else {
                _models.ButtonColumn.update(context, column.id, {
                    parsed_tree: tree
                }).then(()=>{
                // ignore
                }, (err)=>{
                    logger.error(err);
                });
            }
        }
    }
    // todo: improve - implement a common solution for filter, sort, formula, etc
    for (const col of columns){
        columnIdToUidt[col.id] = col.uidt;
        if (col.id in aliasToColumn) continue;
        switch(col.uidt){
            case _nocodbsdk.UITypes.Formula:
            case _nocodbsdk.UITypes.Button:
                {
                    aliasToColumn[col.id] = async ({ tableAlias, parentColumns })=>{
                        parentColumns = (parentColumns != null ? parentColumns : _nocodbsdk.CircularRefContext.make()).cloneAndAdd({
                            id: col.id,
                            title: col.title,
                            table: model.title
                        });
                        const formulOption = await col.getColOptions(context);
                        const { builder } = await _formulaQueryBuilder({
                            baseModelSqlv2,
                            _tree: formulOption.formula,
                            model,
                            aliasToColumn: _extends({}, aliasToColumn, {
                                [col.id]: null
                            }),
                            tableAlias,
                            parsedTree: formulOption.getParsedTree(),
                            baseUsers,
                            parentColumns,
                            getAliasCount,
                            column: col,
                            columns
                        });
                        builder.sql = '(' + builder.sql + ')';
                        return {
                            builder
                        };
                    };
                }
                break;
            case _nocodbsdk.UITypes.Lookup:
            case _nocodbsdk.UITypes.LinkToAnotherRecord:
                aliasToColumn[col.id] = (0, _lookuporltarbuilder.lookupOrLtarBuilder)(_extends({}, params, {
                    column: col,
                    _formulaQueryBuilder,
                    knex
                }));
                break;
            case _nocodbsdk.UITypes.Rollup:
            case _nocodbsdk.UITypes.Links:
                aliasToColumn[col.id] = async ({ tableAlias, parentColumns: parentColumns })=>{
                    const qb = await (0, _genRollupSelectv2.default)({
                        baseModelSqlv2,
                        knex,
                        columnOptions: await col.getColOptions(context),
                        alias: tableAlias,
                        parentColumns
                    });
                    return {
                        builder: knex.raw(qb.builder).wrap('(', ')')
                    };
                };
                break;
            case _nocodbsdk.UITypes.CreatedTime:
            case _nocodbsdk.UITypes.LastModifiedTime:
            case _nocodbsdk.UITypes.DateTime:
                {
                    const refCol = await (0, _helpers.getRefColumnIfAlias)(context, col, columns);
                    if (refCol.id in aliasToColumn) {
                        aliasToColumn[col.id] = aliasToColumn[refCol.id];
                        break;
                    }
                    if (knex.clientType().startsWith('mysql')) {
                        aliasToColumn[col.id] = async ()=>{
                            return {
                                // convert from DB timezone to UTC
                                builder: knex.raw(`CONVERT_TZ(??, @@GLOBAL.time_zone, '+00:00')`, [
                                    refCol.column_name
                                ])
                            };
                        };
                    } else if (knex.clientType() === 'pg' && refCol.dt !== 'timestamp with time zone' && refCol.dt !== 'timestamptz') {
                        aliasToColumn[col.id] = async ()=>{
                            return {
                                // convert from DB timezone to UTC
                                builder: knex.raw(`?? AT TIME ZONE CURRENT_SETTING('timezone') AT TIME ZONE 'UTC'`, [
                                    refCol.column_name
                                ]).wrap('(', ')')
                            };
                        };
                    } else {
                        aliasToColumn[col.id] = ()=>Promise.resolve({
                                builder: refCol.column_name
                            });
                    }
                    aliasToColumn[refCol.id] = aliasToColumn[col.id];
                }
                break;
            case _nocodbsdk.UITypes.User:
            case _nocodbsdk.UITypes.CreatedBy:
            case _nocodbsdk.UITypes.LastModifiedBy:
                {
                    aliasToColumn[col.id] = async ()=>{
                        baseUsers = baseUsers != null ? baseUsers : await _models.BaseUser.getUsersList(context, {
                            base_id: model.base_id,
                            include_internal_user: true
                        });
                        let finalStatement = '';
                        // CreatedBy and LastModifiedBy with system = false has no column_name
                        // need to get it from siblings
                        const columnName = await (0, _dbHelpers.getColumnName)(context, col, columns);
                        // create nested replace statement for each user
                        if (knex.clientType() === 'pg') {
                            finalStatement = `(${(0, _pg.replaceDelimitedWithKeyValuePg)({
                                knex,
                                needleColumn: columnName,
                                stack: baseUsers.map((user)=>({
                                        key: user.id,
                                        value: `${user.email}`
                                    }))
                            })})`;
                        } else if (knex.clientType() === 'sqlite3') {
                            finalStatement = `(${(0, _sqlite3.replaceDelimitedWithKeyValueSqlite3)({
                                knex,
                                needleColumn: columnName,
                                stack: baseUsers.map((user)=>({
                                        key: user.id,
                                        value: `${user.email}`
                                    }))
                            })})`;
                        } else {
                            finalStatement = baseUsers.reduce((acc, user)=>{
                                const qb = knex.raw(`REPLACE(${acc}, ?, ?)`, [
                                    user.id,
                                    user.email
                                ]);
                                return qb.toQuery();
                            }, knex.raw(`??`, [
                                columnName
                            ]).toQuery());
                        }
                        return {
                            builder: knex.raw(finalStatement).wrap('(', ')')
                        };
                    };
                }
                break;
            case _nocodbsdk.UITypes.LongText:
                {
                    var _col_meta;
                    if (((_col_meta = col.meta) == null ? void 0 : _col_meta[_nocodbsdk.LongTextAiMetaProp]) === true) {
                        if (knex.clientType() === 'pg') {
                            aliasToColumn[col.id] = async ()=>{
                                return {
                                    builder: knex.raw(`TRIM('"' FROM (??::jsonb->>'value'))`, [
                                        col.column_name
                                    ])
                                };
                            };
                        } else if (knex.clientType().startsWith('mysql')) {
                            aliasToColumn[col.id] = async ()=>{
                                return {
                                    builder: knex.raw(`JSON_UNQUOTE(JSON_EXTRACT(??, '$.value'))`, [
                                        col.column_name
                                    ])
                                };
                            };
                        } else if (knex.clientType() === 'sqlite3') {
                            aliasToColumn[col.id] = async ()=>{
                                return {
                                    builder: knex.raw(`json_extract(??, '$.value')`, [
                                        col.column_name
                                    ])
                                };
                            };
                        }
                    } else {
                        aliasToColumn[col.id] = ()=>Promise.resolve({
                                builder: col.column_name
                            });
                    }
                    break;
                }
            case _nocodbsdk.UITypes.QrCode:
            case _nocodbsdk.UITypes.Barcode:
                {
                    const referencedColumn = await (await col.getColOptions(context)).getValueColumn(context);
                    aliasToColumn[col.id] = ({ tableAlias })=>Promise.resolve({
                            builder: knex.raw(`??.??`, [
                                tableAlias != null ? tableAlias : baseModelSqlv2.getTnPath(model.table_name),
                                referencedColumn.column_name
                            ])
                        });
                    break;
                }
            default:
                aliasToColumn[col.id] = ({ tableAlias })=>Promise.resolve({
                        builder: knex.raw(`??.??`, [
                            tableAlias != null ? tableAlias : baseModelSqlv2.getTnPath(model.table_name),
                            col.column_name
                        ])
                    });
                break;
        }
    }
    const fn = async (pt, prevBinaryOp)=>{
        if (pt.type === _nocodbsdk.JSEPNode.CALL_EXP) {
            var _pt_arguments_forEach, _pt_arguments;
            (_pt_arguments = pt.arguments) == null ? void 0 : (_pt_arguments_forEach = _pt_arguments.forEach) == null ? void 0 : _pt_arguments_forEach.call(_pt_arguments, (arg)=>{
                var _pt_arguments;
                if (arg.fnName) return;
                arg.fnName = pt.callee.name.toUpperCase();
                arg.argsCount = (_pt_arguments = pt.arguments) == null ? void 0 : _pt_arguments.length;
            });
        }
        // if cast is string, then wrap with STRING() function
        if (pt.cast === _nocodbsdk.FormulaDataTypes.STRING) {
            return fn({
                type: _nocodbsdk.JSEPNode.CALL_EXP,
                arguments: [
                    _extends({}, pt, {
                        cast: null
                    })
                ],
                callee: {
                    type: 'Identifier',
                    name: 'STRING'
                }
            }, prevBinaryOp);
        }
        if (pt.type === _nocodbsdk.JSEPNode.CALL_EXP) {
            return await (0, _parsedtreebuilder.callExpressionBuilder)({
                context,
                pt,
                fn,
                aliasToColumn,
                columnIdToUidt,
                knex,
                model,
                prevBinaryOp
            });
        } else if (pt.type === 'Literal') {
            return {
                builder: knex.raw(`?`, [
                    pt.value
                ])
            };
        } else if (pt.type === 'Identifier') {
            var _aliasToColumn_pt_name;
            const { builder } = await (aliasToColumn == null ? void 0 : (_aliasToColumn_pt_name = aliasToColumn[pt.name]) == null ? void 0 : _aliasToColumn_pt_name.call(aliasToColumn, {
                tableAlias,
                parentColumns: params.parentColumns
            })) || {};
            if (typeof builder === 'function') {
                return {
                    builder: knex.raw(`??`, builder(pt.fnName))
                };
            }
            if (knex.clientType() === 'databricks' && builder.toQuery().endsWith(')')) {
                // limit 1 for subquery
                return {
                    builder: knex.raw(`${builder.toQuery().replace(/\)$/, '')} LIMIT 1)`)
                };
            }
            return {
                builder: knex.raw(`??`, [
                    builder || pt.name
                ])
            };
        } else if (pt.type === 'BinaryExpression') {
            return await (0, _parsedtreebuilder.binaryExpressionBuilder)({
                context,
                pt,
                fn,
                columnIdToUidt,
                knex,
                prevBinaryOp,
                aliasToColumn,
                model
            });
        } else if (pt.type === 'UnaryExpression') {
            let query;
            if ((pt.operator === '-' || pt.operator === '+') && pt.dataType === _nocodbsdk.FormulaDataTypes.NUMERIC) {
                query = knex.raw('?', [
                    (pt.operator === '-' ? -1 : 1) * pt.argument.value
                ]);
            } else {
                query = knex.raw(`${pt.operator}${(await fn(pt.argument, pt.operator)).builder.toQuery()}`);
            }
            if (prevBinaryOp && pt.operator !== prevBinaryOp) {
                query.wrap('(', ')');
            }
            return {
                builder: query
            };
        }
    };
    const builder = (await fn(tree)).builder;
    return {
        builder
    };
}
async function formulaQueryBuilderv2({ baseModel: baseModelSqlv2, tree: _tree, model, column, aliasToColumn = {}, columnIdToUidt = {}, tableAlias, validateFormula = false, parsedTree, baseUsers, parentColumns, columns }) {
    const knex = baseModelSqlv2.dbDriver;
    const context = baseModelSqlv2.context;
    columns = columns != null ? columns : await model.getColumns(context);
    const formulaContext = {
        count: 0
    };
    const getAliasCount = ()=>{
        const result = formulaContext.count++;
        return result;
    };
    let qb;
    try {
        parentColumns = parentColumns != null ? parentColumns : _nocodbsdk.CircularRefContext.make();
        if (column) {
            parentColumns = parentColumns.cloneAndAdd({
                id: column.id,
                title: column.title,
                table: model == null ? void 0 : model.title
            });
        }
        // generate qb
        qb = await _formulaQueryBuilder({
            baseModelSqlv2,
            _tree,
            model,
            aliasToColumn,
            tableAlias,
            columnIdToUidt,
            column,
            parsedTree: parsedTree != null ? parsedTree : await (column == null ? void 0 : column.getColOptions(context).then((formula)=>formula == null ? void 0 : formula.getParsedTree())),
            baseUsers,
            parentColumns,
            columns,
            getAliasCount
        });
        let sqlLength = 0;
        try {
            var _ref;
            var _qb_builder_toSQL_sql, _qb_builder_toSQL, _qb_builder;
            sqlLength = (_ref = qb == null ? void 0 : (_qb_builder = qb.builder) == null ? void 0 : (_qb_builder_toSQL = _qb_builder.toSQL) == null ? void 0 : (_qb_builder_toSQL_sql = _qb_builder_toSQL.call(_qb_builder).sql) == null ? void 0 : _qb_builder_toSQL_sql.length) != null ? _ref : 0;
        } catch (ex) {}
        // we limit the formula length to 500k to prevent server crashing
        if (sqlLength > 500 * 1000) {
            const columnInfo = {
                title: (column == null ? void 0 : column.title) ? `column ${column.title}` : 'new column',
                id: (column == null ? void 0 : column.id) ? ` (${column.id})` : ''
            };
            _telemetryhandlerservice.TelemetryHandlerService.sendPriorityError(context, {
                trigger: 'formulaQueryBuilder',
                error_type: 'FORMULA_TOO_LONG_ERROR',
                message: `Formula length too long for ${columnInfo.title}${columnInfo.id}`
            });
            _catchError.NcError.get(context).formulaError(`Formula length too long for ${columnInfo.title}`);
        }
        if (!validateFormula) return qb;
        // Short-circuit if a previous dry-run already failed for this base model,
        // to avoid amplifying requests to an overwhelmed external source
        if (baseModelSqlv2.formulaDryRunFailed) {
            throw new Error('Skipping formula dry-run: a previous validation already failed');
        }
        // dry run qb.builder to see if it will break the grid view or not
        // if so, set formula error and show empty selectQb instead
        await baseModelSqlv2.execAndParse(knex(baseModelSqlv2.getTnPath(model, tableAlias)).select(knex.raw(`?? as ??`, [
            qb.builder,
            '__dry_run_alias'
        ])).as('dry-run-only'), null, {
            raw: true
        });
        // if column is provided, i.e. formula has been created
        if (column) {
            var // clear context cache if present since metadata has changed
            _context_cacheMap;
            const formula = await column.getColOptions(context);
            // clean the previous formula error if the formula works this time
            if (formula.error) {
                if (formula.constructor.name === 'ButtonColumn') {
                    await _models.ButtonColumn.update(_extends({}, context, {
                        cache: false
                    }), column.id, {
                        error: null
                    });
                } else {
                    await _FormulaColumn.default.update(_extends({}, context, {
                        cache: false
                    }), column.id, {
                        error: null
                    });
                }
            }
            (_context_cacheMap = context.cacheMap) == null ? void 0 : _context_cacheMap.clear();
        }
    } catch (e) {
        var _ref1;
        // Check if this is a transient error (connection/timeout issue)
        const isTransient = (0, _utils.isTransientError)(e);
        // Mark formula error if formula validation is invoked
        // or if a circular reference error occurs and a column is provided
        // BUT skip marking for transient errors
        if (!isTransient && (validateFormula || (column == null ? void 0 : column.id) && e instanceof _catchError.NcBaseErrorv2 && e.error === _nocodbsdk.NcErrorType.ERR_CIRCULAR_REF_IN_FORMULA)) {
            console.error(e);
            if (column) {
                if ((column == null ? void 0 : column.uidt) === _nocodbsdk.UITypes.Button) {
                    await _models.ButtonColumn.update(context, column.id, {
                        error: null
                    });
                    // update cache to reflect the error in UI
                    await _NocoCache.default.update(context, `${_globals.CacheScope.COL_BUTTON}:${column.id}`, {
                        error: e.message
                    });
                } else {
                    // add formula error to show in UI
                    await _FormulaColumn.default.update(context, column.id, {
                        error: e.message
                    });
                    // update cache to reflect the error in UI
                    await _NocoCache.default.update(context, `${_globals.CacheScope.COL_FORMULA}:${column.id}`, {
                        error: e.message
                    });
                }
            }
        } else {
            // Mark dry-run as failed so subsequent formula validations on the same
            // base model short-circuit instead of hammering an unreachable source
            if (isTransient && validateFormula) {
                baseModelSqlv2.formulaDryRunFailed = true;
            }
            throw e;
        }
        // if it's a formula error, throw it
        if (e instanceof _catchError.NcBaseErrorv2) {
            throw e;
        }
        const dbError = _extractor.DBErrorExtractor.get().extractDbError(e, {
            clientType: baseModelSqlv2.clientType,
            ignoreDefault: true
        });
        _catchError.NcError.get(context).formulaError((_ref1 = dbError == null ? void 0 : dbError.message) != null ? _ref1 : e.message);
    }
    return qb;
}
